
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState, useEffect } from 'react';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link.js';
import { cachedDataWrapper } from '../lib/dataFetcher';
import Pulse from '../components/Pulse';
import FormattedDate from '../components/FormattedDate';
import RelatedLinks from '../components/RelatedLinks';
import TransportBoard from '../components/TransportBoard';
async function getStaticProps() {
    try {
        const data = await cachedDataWrapper();
        return {
            props: {
                initialData: data
            },
            revalidate: 60 // Revalidate every minute
        };
    }
    catch (error) {
        console.error('Error fetching data:', error);
        return {
            props: {
                initialData: {
                    error: "Something went wrong. I'm probably working on it!"
                }
            },
            revalidate: 60 // Revalidate every minute
        };
    }
}
function PassportTimes({ initialData }) {
    const [data, setData] = useState(initialData);
    const { t, lang } = useTranslation('passport-control');
    const fetchData = async () => {
        try {
            const response = await fetch('/api/fetchData'); // Assuming you have an API route for fetching data
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            setData(data);
        }
        catch (e) {
            // Handle error
            setData({
                error: "Something went wrong. I'm probably already working on it!"
            });
        }
    };
    useEffect(() => {
        const fetchDataAndSetInterval = () => {
            // Fetch data immediately on mount
            fetchData();
            const intervalId = setInterval(() => {
                fetchData();
            }, 1000 * 60 * 1); // Fetch every minute
            // Cleanup the interval when the component unmounts
            return () => {
                clearInterval(intervalId);
            };
        };
        fetchDataAndSetInterval(); // Call the function to set up the interval
        // Specify an empty dependency array to ensure this effect runs only once
    }, []);
    return (<div className="bg-white p-4 my-auto rounded">
            <div>{t('passport-control:intro')}</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 my-4 *:bg-gray-100 *:p-4 *:rounded *:shadow-lg">
                <div>
                    <div>Terminal C</div>
                    <div className="text-3xl">{data.passportTimes.C.text}</div>
                    <div className="text-xs text-gray-500">
                        {t('common:last_updated')}:{' '}
                        <FormattedDate date={data.lastUpdated} locale={lang}/>
                        <Pulse className="relative inline-flex ml-2"/>
                    </div>
                </div>
                <div>
                    <div>Terminal E/F</div>
                    <div className="text-3xl">{data.passportTimes.F.text}</div>
                    <div className="text-xs text-gray-500">
                        {t('common:last_updated')}:{' '}
                        <FormattedDate date={data.lastUpdated} locale={lang}/>
                        <Pulse className="relative inline-flex ml-2"/>
                    </div>
                </div>
            </div>
            <div className="mt-4">
                <div>{t('passport-control:about')}</div>
                <div className="my-5 p-5 bg-orange-100">
                    <div className="text-xl">{t('advice_header')}</div>
                    <ol className="list-decimal list-inside *:my-2">
                        <li>{t('passport-control:advice_1')}</li>
                        <li>{t('passport-control:advice_2')}</li>
                        <li>
                            {t('passport-control:advice_3')}{' '}
                            <Link href="/departures" className="underline">
                                {t('common:departures')}
                            </Link>{' '}
                            {t('common:or')}{' '}
                            <Link href="/arrivals" className="underline">
                                {t('common:arrivals')}
                            </Link>
                        </li>
                        <li>{t('passport-control:advice_4')}</li>
                        <li>{t('passport-control:advice_5')}</li>
                    </ol>
                </div>
            </div>

            <TransportBoard />

            <RelatedLinks links={[
            {
                href: '/blog/cph-passport-control-wait',
                labelKey: 'link_passport_guide'
            },
            {
                href: '/blog/how-early-to-arrive-at-cph',
                labelKey: 'link_how_early'
            }
        ]}/>
        </div>);
}
export default PassportTimes;

    async function __Next_Translate__getStaticProps__1a1723ec68b__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/passport-control',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec68b__ as getStaticProps }
  